"use client";
import { useEffect } from "react";
import { useTranslations } from "use-intl";

export const useDisableScroll = (isHidden: boolean) => {
  useEffect(() => {
    if (isHidden) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      // Cleanup on unmount or when isHidden changes
      document.body.style.overflow = "";
    };
  }, [isHidden]);
};

export const spaceTypes = ["indoorSpace", "balcony", "terrace", "privateRoom"];

export const useSpaceTypeTranslation = (spaceType: string, g?: any) => {
  if (!spaceTypes.includes(spaceType)) {
    return spaceType;
  } else {
    if (g) {
      return g(spaceType);
    } else {
      const general = useTranslations("General");
      return general(spaceType);
    }
  }
};
